import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'ngx-popup',
  styleUrls: ['./popup.component.scss'],
  templateUrl: './popup.component.html'
})
export class PopupComponent implements OnInit {
  isPopupVisible: boolean = false;
  isConfirmVisible: boolean = false;
  message: string = '';
  iconClass: string = '';
  yesAction?: () => void;
  noAction?: () => void;

  constructor(private popupService: PopupService) { }

  ngOnInit(): void {
    // Subscribe to the popup visibility, message, and icon
    this.popupService.popupVisibility$.subscribe(visible => {
      this.isPopupVisible = visible;
    });

    this.popupService.message$.subscribe(message => {
      this.message = message;
    });

    this.popupService.iconClass$.subscribe(iconClass => {
      this.iconClass = iconClass;
    });

    //---Model Popup Code Start---//

    this.popupService.confirmVisibility$.subscribe(visible => {
      this.isConfirmVisible = visible;
    });

    this.popupService.confirmActions$.subscribe((actions) => {
      this.yesAction = actions.yes;
      this.noAction = actions.no;
    });

  }

  // Close the popup when the close button is clicked
  closePopup(): void {
    this.popupService.hidePopup();
  }



  handleYes(): void {
    if (this.yesAction) {
      this.yesAction();
    }
  }

  handleClose(): void {
    if (this.noAction) {
      this.noAction();
    }
    this.popupService.hideConfirmPopup();
  }

}
